import { Skeleton } from "@/components/ui/skeleton";

export default function OrderDetailLoader() {
  return (
    <div className="flex flex-col gap-4 mb-7">
      <div>
        <Skeleton className="h-8 w-40" />
      </div>
      <div className="flex justify-between items-end gap-4">
        <div className="flex gap-4">
          <Skeleton className="h-6 w-16" />
          <Skeleton className="h-6 w-16" />
          <Skeleton className="h-6 w-16" />
        </div>
        <div className="flex gap-4">
          <Skeleton className="h-10 w-24" />
          <Skeleton className="h-10 w-24" />
        </div>
      </div>
    </div>
  );
}
